import React from 'react';
const PerLead = ({ error, body, setBody }) => {
	const [perLeadSwitch, togglePerLeadSwitch] = React.useState(false);
	const changeStatus = e => {
		if (e.target.checked) {
			body.per_lead = {};
			setBody(body);
		} else {
			body.per_lead = undefined;
		}

		togglePerLeadSwitch(e.target.checked);
		// if (!e.target.checked) setBody({ ...body, per_lead: undefined });
	};
	React.useEffect(() => {
		if (body.per_lead) {
			togglePerLeadSwitch(true);
		}
	}, []);
	return (
		<div className='mx-3 mt-3'>
			<div className='row'>
				<div className='col-md-2'>
					<h6 className='mt-2'>Per Lead</h6>
				</div>
				<div className='col-md-3'>
					<label className='switch'>
						<input
							checked={perLeadSwitch}
							value={perLeadSwitch}
							onChange={changeStatus}
							className='switch-input'
							type='checkbox'
						/>
						<span className='switch-label' data-on='On' data-off='Off' />{' '}
						<span className='switch-handle' />{' '}
					</label>
				</div>
			</div>
			{perLeadSwitch && (
				<>
					{' '}
					<div className='col-md-3 p-0'>
						<div className='form-group'>
							<label>
								Type <tt>*</tt>
							</label>
							<select
								value={body?.per_lead?.amt_type}
								onChange={e =>
									setBody({
										...body,
										per_lead: { ...body.per_lead, amt_type: e.target.value }
									})
								}
								className='form-control'
							>
								<option value={null}>Select Type</option>
								<option value='fixed'>Fixed Amount</option>
								<option value='percent'>Percentage</option>
							</select>
							{error && (
								<p className='mt-2 mb-0 text-danger'>
									{error?.fields?.['per_lead.amt_type']?.[0]}
								</p>
							)}
						</div>
					</div>
					<div className='col-md-3'>
						<div className='form-group row'>
							<label htmlFor className=' col-md-4 px-0 col-form-label'>
								Secured <tt>*</tt>
							</label>
							<div className='col-md-8 p-0'>
								<input
									value={body?.per_lead?.base_payout_sec}
									onChange={e =>
										setBody(value => ({
											...value,
											per_lead: {
												...value.per_lead,
												base_payout_sec: e.target.value
											}
										}))
									}
									type={'number'}
									className='form-control'
									id
									placeholder={
										body?.per_lead?.amt_type === 'percent'
											? 'Fixed Percentage'
											: 'Fixed Amount'
									}
								/>
							</div>
						</div>
						{error && (
							<p className='mt-2 mb-0 text-danger'>
								{error?.fields?.['per_lead.base_payout_sec']?.[0]}
							</p>
						)}
					</div>
					<div className='col-md-3'>
						<div className='form-group row'>
							<label htmlFor className=' col-md-4 px-0 col-form-label'>
								Unsecured <tt>*</tt>
							</label>
							<div className='col-md-8 p-0'>
								<input
									value={body?.per_lead?.base_payout_unsec}
									onChange={e =>
										setBody(value => ({
											...value,
											per_lead: {
												...value.per_lead,
												base_payout_unsec: e.target.value
											}
										}))
									}
									type={'number'}
									className='form-control'
									id
									placeholder={
										body?.per_lead?.amt_type === 'percent'
											? 'Fixed Percentage'
											: 'Fixed Amount'
									}
								/>
							</div>
						</div>
						{error && (
							<p className='mt-2 mb-0 text-danger'>
								{error?.fields?.['per_lead.base_payout_unsec']?.[0]}
							</p>
						)}
					</div>
				</>
			)}
		</div>
	);
};

export default PerLead;
